export const About = () => {
    return (
        <div className="about__container">
            <h2>Nosotros</h2>
            <p>Nos alegra saber que al construir una piscina Dent, también creamos un espacio para compartir momentos inolvidables.</p>
        </div>
    )
}
